import React, { Component } from 'react';
import { string, func, bool } from 'prop-types';
import './Radio.scss'

export default class Radio extends Component {
  render() {
    const { label, onChange, value, isChecked } = this.props
    return (
      <div className="radio_container" key={label} >
        <input 
          type="radio"
          name="inlineRadioOptions"
          id={`item-type-${value}`}
          value={value}
          checked={isChecked}
          onChange={onChange}
        />
        <label
          htmlFor={`item-type-${value}`}
        >
          {label}
        </label>
      </div>
    )
  }
}

Radio.propTypes = {
  label: string,
  value: string,
  onChange: func,
  isChecked: bool
};

Radio.defaultProps = {
  label: '',
  value: '',
  onChange: () => { },
  isChecked: false
};

